import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";
import ReadpointService from "../../services/ReadpointService";

class TransactionStatusSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Status da Transação',
      label: ['name'],
      value: 'id',
      url: 'ton/v1/transactions/status'
    };
  }
}

TransactionStatusSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default TransactionStatusSelector;



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionStatusSelector.js